import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/components/admin/api";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminInbox } from "@/components/admin/AdminInbox";

export default function AdminPage() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const check = async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        try {
          const { data } = await api.post("/auth/refresh");
          setUser(data);
        } catch {
          setUser(false);
        }
      }
    };
    check();
  }, []);

  const logout = useCallback(() => setUser(false), []);

  if (user === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#E4E4E4]" data-testid="admin-loading">
        <Loader2 className="h-8 w-8 animate-spin text-black" />
      </div>
    );
  }
  return user ? <AdminInbox user={user} onLogout={logout} /> : <AdminLogin onLogin={setUser} />;
}
